// To use for default statement in switch where all cases must be covered
import { makeReadable } from './makeReadable';

export class ShouldNotHappen extends Error {
  public constructor(val: never) {
    super(`this should not happen: ${makeReadable(val)}`);
  }
}
